<template>
  <QDialog v-model="showDialog" @hide="onDialogHide()" :no-esc-dismiss="true" :persistent="true" style="width: 240px">
    <QCard style="padding: 25px 0">
      <div class="row justify-center items-center q-pa-md" style="width: 100%">
        <div class="col-12" style="text-align: center">
          <img
            :src="popupImage ? popupImage : '/assets/images/Illustration.svg'"
            class="header-logo"
            style="max-width: 200px; max-height: 200px"
          />
        </div>
        <div class="col-12" style="text-align: center; padding-top: 10px">
          <h5>You're inviting an Authorised Officer</h5>
          <p>
            The Authorised Officer of {{ company }} is needed to review and approve a vehicle quote, complete a credit application and sign
            a lease agreement.
          </p>
          <br />
          <p>Your access to the application will be removed.</p>
        </div>
        <div class="col-md-8 col-sm-12" style="text-align: center"></div>
      </div>
      <div class="text-center">
        <QBtn color="primary" no-caps @click="onCancel()">Logout</QBtn>
      </div>
    </QCard>
  </QDialog>
</template>

<script>
import { QBtn, QDialog, QCard } from 'quasar';
import { mapGetters } from 'vuex';

export default {
  name: 'NewApplicantDialog',
  components: { QBtn, QDialog, QCard },
  data: function () {
    return {
      showDialog: true
    };
  },
  props: {
    company: String
  },
  computed: {
    ...mapGetters({ orgProfile: 'theme/getScoreboard' }),
    popupImage() {
      if (this.orgProfile?.popupImage2) {
        return this.orgProfile.popupImage2;
      } else {
        return null;
      }
    }
  },
  created() {},
  methods: {
    onCancel: function () {
      setTimeout(() => {
        this.$emit('closeNewApplicantDialog');
        this.showDialog = false;
      });
    },
    onDialogHide: function () {
      this.showDialog = false;
      setTimeout(() => {
        this.showDialog = true;
      });
    }
  }
};
</script>
